import React, { FC, useEffect, useRef, useState } from 'react';
import { PatternFormat } from 'react-number-format';
import { intervalToDuration } from 'date-fns';
import MfButton from '../UI/Button/MfButton';
import { confirmCodeSmsCreate } from '../../api/smsCode';
import { SmsCodeResponse } from '../../structures/response/SmsCodeResponse';
import { CodeValidatedActionEnum } from '../../enum/CodeValidatedActionEnum';
import MfDialog from '../UI/Dialog/MfDialog';
import MfAlert from '../UI/Alert/MfAlert';

interface Props {
  phone: string;
  recaptchaRequired?: boolean;
  action: CodeValidatedActionEnum;
  format: string;
  prefix: string;
  onCodeRequested?: () => void;
}

const RequestCodeForm: FC<Props> = ({
  phone,
  recaptchaRequired,
  action,
  format,
  prefix,
  onCodeRequested,
}) => {
  const [recaptchaError, setRecaptchaError] = useState(false);
  const [processing, setProcessing] = useState(false);
  const intervalId = useRef<ReturnType<typeof setInterval> | null>(null);
  const [resendAt, setResendAt] = useState(0);
  const [displayTime, setDisplayTime] = useState('');

  useEffect(() => {
    const script = document.createElement('script');
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.onloadCallback = function () {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.grecaptcha.render('grecaptcha', {
        sitekey: '6LcgdModAAAAACCYn3LZUOzU2cTgIbS4QdPBDg14',
      });
    };
    script.src =
      'https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit';

    document.head.appendChild(script);
  }, []);

  useEffect(() => {
    if (
      recaptchaRequired === true &&
      resendAt === 0 &&
      typeof (window as any).grecaptcha?.render === 'function'
    ) {
      setTimeout(() => {
        (window as any).grecaptcha?.render('grecaptcha', {
          sitekey: '6LcgdModAAAAACCYn3LZUOzU2cTgIbS4QdPBDg14',
        });
      }, 0);
    }
  }, [resendAt, recaptchaRequired]);

  useEffect(() => {
    createSMSTimeout();
  }, [resendAt]);

  const handleRequestSmsCode = async () => {
    let gRecaptchaCode = '';
    if (
      recaptchaRequired &&
      typeof (window as any).grecaptcha?.render === 'function'
    ) {
      const el = document.querySelector(
        '.g-recaptcha-response'
      ) as HTMLInputElement;
      gRecaptchaCode = el.value;
      if (!gRecaptchaCode) {
        setRecaptchaError(true);
        return false;
      }
    }

    setProcessing(true);

    try {
      const result: SmsCodeResponse = await confirmCodeSmsCreate(
        action,
        `${phone}`.substring(-10),
        gRecaptchaCode
      );
      setResendAt(result.resendAt);
      // this.setState({ resendAt }, () => this.createSMSTimeout());
      if (typeof onCodeRequested === 'function') {
        onCodeRequested();
      }
    } catch (e) {
      console.log(e); // todo: remove this line
    }
    setProcessing(false);
    return true;
  };

  const createSMSTimeout = () => {
    if (intervalId.current) {
      clearInterval(intervalId.current);
    }
    intervalId.current = setInterval(() => {
      if (resendAt > 0) {
        const duration = intervalToDuration({ start: 0, end: resendAt * 1000 });
        const minutes = duration.minutes?.toString().padStart(2, '0');
        const seconds = duration.seconds?.toString().padStart(2, '0');
        const formatted = `${minutes}:${seconds}`;
        setDisplayTime(formatted);
        setResendAt((v) => v - 1);
      }
    }, 1000);
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <MfAlert
          severity="info"
          style={{
            fontSize: '12px',
            marginBottom: '1rem',
            marginTop: '0.5rem',
            textAlign: 'left',
          }}
        >
          SMS код будет выслан на номер{' '}
          <div style={{ display: 'inline-block' }}>
            <span style={{ fontWeight: 600 }}>
              {prefix}
              <PatternFormat value={phone} format={format} displayType="text" />
            </span>{' '}
            или в приложение Money Friends.
          </div>
          {resendAt > 0 && (
            <div>
              Повторно выслать SMS с кодом подтверждения можно через&nbsp;
              <span style={{ fontWeight: 600 }}>{displayTime}</span>
            </div>
          )}
        </MfAlert>
      </div>
      <div className="col-md-12">
        <div
          id="grecaptcha"
          style={{ display: 'flex', justifyContent: 'center' }}
        />
        <MfButton
          onClick={handleRequestSmsCode}
          variant="contained"
          color="secondary"
          sx={{ mt: 3 }}
          disabled={resendAt > 0}
        >
          <span>Получить код подтверждения</span>
        </MfButton>
        {/* {error && <div className="text-danger">{error}</div>} */}
      </div>
      <MfDialog
        title="Запрос SMS кода"
        onClose={() => setRecaptchaError(false)}
        open={recaptchaError}
        maxWidth="xs"
        fullScreen={false}
      >
        Подтвердите, что вы не робот
      </MfDialog>
    </div>
  );
};

RequestCodeForm.defaultProps = {
  recaptchaRequired: false,
  onCodeRequested: undefined,
};

export default RequestCodeForm;
